//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';
import { useTheme } from '@mui/material/styles';

// === STYLE / MATERIAL UI ===
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { CorrectionMode } from 'pages/Menu/CorrectionMode/CorrectionMode';

//#endregion

//-----------------------------------------------------------------
export function TaskVerifyHeader() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const _styles = {
    container: {
      display: 'flex',
      padding : '0.5rem' ,
      width   : '100%' ,
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container} >
        <CorrectionMode />
      </Box>
    )
  }

  //#endregion

  return display();
}
